(function(){
  function init(){
    if (typeof gsap === 'undefined') return;
    gsap.registerPlugin(ScrollTrigger);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isTouch = window.matchMedia('(pointer:coarse)').matches;

    /* ---------- real brand logo (header + footer) ---------- */
    if (window.VistillionAssets) {
      var headerLogoSpan = document.querySelector('.header__heading-link .h2');
      if (headerLogoSpan) {
        var headerWrap = document.createElement('div');
        headerWrap.className = 'header__heading-logo-wrapper';
        var headerImg = document.createElement('img');
        headerImg.src = window.VistillionAssets.wordmarkCream;
        headerImg.alt = 'Vistillion';
        headerImg.className = 'header__heading-logo v-header-logo';
        headerWrap.appendChild(headerImg);
        headerLogoSpan.replaceWith(headerWrap);
      }
      var footerBrand = document.querySelector('.footer-block__brand-info');
      if (footerBrand && !footerBrand.querySelector('.v-footer-logo')) {
        var footerImg = document.createElement('img');
        footerImg.src = window.VistillionAssets.wordmarkCream;
        footerImg.alt = 'Vistillion';
        footerImg.className = 'v-footer-logo';
        footerBrand.insertBefore(footerImg, footerBrand.firstChild);
      }
    }

    /* ---------- custom cursor ---------- */
    if(!isTouch && !document.getElementById('curDot')){
      var dot = document.createElement('div'); dot.className='cur cur-dot'; dot.id='curDot';
      var ring = document.createElement('div'); ring.className='cur cur-ring'; ring.id='curRing';
      document.body.appendChild(dot); document.body.appendChild(ring);
      var mx=innerWidth/2,my=innerHeight/2, rx=mx, ry=my;
      window.addEventListener('mousemove', function(e){mx=e.clientX;my=e.clientY;
        dot.style.transform='translate('+mx+'px,'+my+'px) translate(-50%,-50%)';});
      gsap.ticker.add(function(){ rx+=(mx-rx)*0.16; ry+=(my-ry)*0.16;
        ring.style.transform='translate('+rx+'px,'+ry+'px) translate(-50%,-50%)'; });
      document.querySelectorAll('[data-hover]').forEach(function(el){
        el.addEventListener('mouseenter', function(){ring.classList.add('big');});
        el.addEventListener('mouseleave', function(){ring.classList.remove('big');});
      });
    }

    /* ---------- magnetic buttons ---------- */
    if(!isTouch){
      document.querySelectorAll('[data-magnetic]').forEach(function(wrap){
        var el = wrap.querySelector('a,button');
        if(!el) return;
        wrap.addEventListener('mousemove', function(e){
          var r = wrap.getBoundingClientRect();
          var x = e.clientX - r.left - r.width/2, y = e.clientY - r.top - r.height/2;
          gsap.to(el, {x:x*0.35, y:y*0.5, duration:.4, ease:'power3.out'});
        });
        wrap.addEventListener('mouseleave', function(){gsap.to(el, {x:0,y:0,duration:.6,ease:'elastic.out(1,0.4)'});});
      });
    }

    /* ---------- product media gallery interactions ---------- */
    (function(){
      var galleries = document.querySelectorAll('media-gallery');
      if(!galleries.length) return;
      galleries.forEach(function(gallery){
        var items = gallery.querySelectorAll('.product__media-item');
        var coteSrc = null;
        items.forEach(function(item){
          var img = item.querySelector('.product__media > img');
          if(!img) return;
          var src = img.currentSrc || img.src || '';
          if(!coteSrc && /cote/i.test(src)) coteSrc = src;
        });
        if(coteSrc){
          items.forEach(function(item){
            var img = item.querySelector('.product__media > img');
            if(!img) return;
            var src = img.currentSrc || img.src || '';
            if(/face/i.test(src) && src !== coteSrc && !item.querySelector('.v-media-reveal')){
              var media = item.querySelector('.product__media');
              if(media){
                var overlay = document.createElement('img');
                overlay.src = coteSrc;
                overlay.alt = '';
                overlay.setAttribute('aria-hidden', 'true');
                overlay.className = 'v-media-reveal';
                media.appendChild(overlay);
                var tag = document.createElement('span');
                tag.className = 'v-media-reveal-tag';
                tag.setAttribute('aria-hidden', 'true');
                tag.textContent = 'See The Acrylic Edge';
                media.appendChild(tag);

                /* auto "peek" reveal on scroll-into-view: demonstrates the
                   crossfade on every device, since hover never fires on touch */
                var peekContainer = item.querySelector('.product-media-container');
                if(peekContainer && 'IntersectionObserver' in window){
                  var peeked = false;
                  var io = new IntersectionObserver(function(entries){
                    entries.forEach(function(entry){
                      if(entry.isIntersecting && !peeked){
                        peeked = true;
                        setTimeout(function(){
                          peekContainer.classList.add('v-revealed');
                          setTimeout(function(){ peekContainer.classList.remove('v-revealed'); }, 1500);
                        }, 500);
                        io.disconnect();
                      }
                    });
                  }, {threshold:0.45});
                  io.observe(peekContainer);
                }
              }
            }
          });
        }
        if(!isTouch){
          gallery.querySelectorAll('.product-media-container').forEach(function(container){
            var media = container.querySelector('.product__media');
            if(!media) return;
            container.addEventListener('mousemove', function(e){
              var r = container.getBoundingClientRect();
              var px = (e.clientX - r.left) / r.width - .5;
              var py = (e.clientY - r.top) / r.height - .5;
              media.style.transform = 'scale(1.035) rotateX(' + (py * -3.5) + 'deg) rotateY(' + (px * 3.5) + 'deg)';
            });
            container.addEventListener('mouseleave', function(){ media.style.transform = ''; });
          });
        }
      });
    })();

    /* ---------- product page: info + media entrance reveal ---------- */
    (function(){
      var mediaWrapper = document.querySelector('product-info.color-scheme-1 .product__media-wrapper') || document.querySelector('.product__media-wrapper');
      if(mediaWrapper){
        gsap.from(mediaWrapper, {opacity:0, scale:.94, duration:1, ease:'power3.out',
          scrollTrigger:{trigger:mediaWrapper, start:'top 85%'}});
      }
      var infoContainer = document.querySelector('product-info.color-scheme-1 .product__info-container') || document.querySelector('.product__info-container');
      if(infoContainer){
        var infoKids = Array.prototype.filter.call(infoContainer.children, function(el){
          return el.tagName !== 'SCRIPT' && el.tagName !== 'LINK';
        });
        gsap.from(infoKids, {opacity:0, y:20, duration:.7, stagger:.06, ease:'power3.out',
          scrollTrigger:{trigger:infoContainer, start:'top 85%'}});
      }
    })();

    /* ---------- hero background video ---------- */
    var heroVideo = document.getElementById('heroBgVideo');
    if(heroVideo && reduceMotion){
      heroVideo.pause();
      heroVideo.removeAttribute('autoplay');
    }

    /* ---------- hero intro reveal ---------- */
    var hero = document.querySelector('.v-hero');
    if(hero){
      gsap.set(hero.querySelectorAll('.ovh-inner'), {y:'110%'});
      gsap.set(hero.querySelector('.v-hero-mark'), {opacity:0, y:14, scale:.9});
      gsap.set(hero.querySelector('.v-hero-glow'), {opacity:0, scale:.8});
      gsap.set(hero.querySelector('.v-hero-cta-row'), {opacity:0, y:16});
      var tl = gsap.timeline({defaults:{ease:'power3.out'}, delay:.2});
      tl.to(hero.querySelector('.v-hero-glow'), {opacity:1, scale:1, duration:1.6, ease:'power2.out'}, 0)
        .to(hero.querySelectorAll('.v-hero-kicker .ovh-inner'), {y:'0%', duration:.7}, 0.1)
        .to(hero.querySelector('.v-hero-mark'), {opacity:1, y:0, scale:1, duration:.9}, '-=0.35')
        .to(hero.querySelectorAll('.v-hero-slogan .ovh-inner'), {y:'0%', duration:.9}, '-=0.55')
        .to(hero.querySelectorAll('.v-hero-sub .ovh-inner'), {y:'0%', duration:.8}, '-=0.6')
        .to(hero.querySelector('.v-hero-cta-row'), {opacity:1, y:0, duration:.7}, '-=0.5');
    }

    /* ---------- hero float 3D tilt ---------- */
    var floatWrap = document.getElementById('heroFloat');
    var floatInner = document.getElementById('heroFloatInner');
    if(floatWrap && floatInner && !isTouch){
      floatWrap.addEventListener('mousemove', function(e){
        var r = floatWrap.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        var rotY = (px - .5) * 30, rotX = (.5 - py) * 22;
        gsap.to(floatInner, {rotateY:rotY, rotateX:rotX, scale:1.05, duration:.5, ease:'power2.out', transformPerspective:900});
      });
      floatWrap.addEventListener('mouseleave', function(){
        gsap.to(floatInner, {rotateY:0, rotateX:0, scale:1, duration:.8, ease:'elastic.out(1,0.5)'});
      });
    }

    /* ---------- section header reveal (number / title / count) ---------- */
    document.querySelectorAll('.v-index-head').forEach(function(head){
      gsap.from(head.children, {opacity:0, y:16, duration:.6, stagger:.08, ease:'power3.out',
        scrollTrigger:{trigger:head, start:'top 90%'}});
    });

    /* ---------- arc carousel: posters fanned on an arc, rotated by scroll ---------- */
    (function(){
      var arcStage = document.getElementById('arcStage');
      if(!arcStage) return;
      var cards = Array.prototype.slice.call(arcStage.querySelectorAll('.v-arc-card'));
      var infoItems = Array.prototype.slice.call(document.querySelectorAll('.v-arc-info-item'));
      var n = cards.length;
      if(!n) return;
      var ANGLE = 32;
      var currentActive = 0;

      function radius(){
        /* offsetWidth is the pre-transform layout width, so it stays stable
           even while the card itself is mid-rotation (getBoundingClientRect
           would shrink as the card foreshortens, feeding back into a
           collapsing radius and making later cards collide) */
        var img = cards[0].querySelector('img');
        var w = img ? img.offsetWidth : 0;
        return (w || Math.min(window.innerWidth, 1400) * 0.32) * 1.65;
      }

      /* how much of the gap between two posters (as a fraction, 0-1) stays
         perfectly flat/centered on each side of the active one: this is what
         makes the front poster land dead-straight (and stay straight for a
         moment) instead of always sitting at some in-between rotation, which
         is what made its clickable area drift away from the visible image */
      var DEADZONE = 0.26;

      function render(active){
        currentActive = active;
        var RADIUS = radius();
        cards.forEach(function(card, i){
          var d = i - active;
          var ad = Math.abs(d);
          var sign = d < 0 ? -1 : 1;
          var adEased = Math.max(0, ad - DEADZONE);
          var dc = sign * Math.min(3, adEased);
          var angle = dc * ANGLE;
          var rad = angle * Math.PI / 180;
          var x = Math.sin(rad) * RADIUS;
          var z = (Math.cos(rad) - 1) * RADIUS;
          var scale = Math.max(0.6, 1 - adEased * 0.14);
          var opacity = Math.max(0, 1 - adEased * 0.38);
          card.style.transform = 'translate(-50%,-50%) translate3d(' + x.toFixed(1) + 'px,0,' + z.toFixed(1) + 'px) rotateY(' + (-angle).toFixed(2) + 'deg) scale(' + scale.toFixed(3) + ')';
          card.style.opacity = opacity;
          card.style.zIndex = String(200 - Math.round(adEased * 10));
          card.style.pointerEvents = ad <= DEADZONE ? 'auto' : 'none';
        });
        var nearest = Math.max(0, Math.min(n - 1, Math.round(active)));
        /* match by data-index rather than array position: the left/right
           description panels and the bottom price panel are three separate
           groups of .v-arc-info-item, so a raw loop index would only ever
           line up correctly for the first group */
        infoItems.forEach(function(item){
          item.classList.toggle('is-active', Number(item.dataset.index) === nearest);
        });
      }

      render(0);
      window.addEventListener('resize', function(){ render(currentActive); });

      if(n > 1){
        var isMobileArc = window.innerWidth <= 860;
        gsap.to({v:0}, {
          v: n - 1,
          ease:'none',
          scrollTrigger: isMobileArc ? {
            trigger:'.v-arc-section', start:'top bottom', end:'bottom top', scrub:0.6
          } : {
            trigger:'.v-arc-section', start:'top top', pin:true, scrub:0.6,
            end: '+=' + (n * 480),
            invalidateOnRefresh:true
          },
          onUpdate: function(){ render(this.targets()[0].v); }
        });
      }
    })();

    /* ---------- collection image reveal ---------- */
    document.querySelectorAll('[data-reveal]').forEach(function(el){
      gsap.to(el, {
        clipPath:'inset(0 0 0% 0)', duration:1.3, ease:'power4.out',
        scrollTrigger:{trigger:el, start:'top 85%'}
      });
      var img = el.querySelector('img');
      if(img){
        gsap.fromTo(img, {y:-40}, {
          y:0, ease:'none',
          scrollTrigger:{trigger:el, start:'top bottom', end:'bottom top', scrub:0.6}
        });
      }
    });
    document.querySelectorAll('.v-spread-text').forEach(function(el){
      gsap.from(el.children, {opacity:0, y:24, duration:.8, stagger:.08, ease:'power3.out',
        scrollTrigger:{trigger:el, start:'top 75%'}});
    });

    /* ---------- material reveal: poster rotates through construction story on scroll ----------
       NOTE: this pin MUST be created before the manifesto pin below, since the reveal
       section sits earlier in the DOM (03) than the manifesto (04). GSAP measures each
       pinned trigger's position at creation time — creating manifesto's pin first would
       size it against a page that doesn't yet include this section's pin-spacer, leaving
       a stale (too-short) start/end and a blank gap once this section's spacer is inserted. */
    (function(){
      var stage = document.getElementById('revealStage');
      if(!stage) return;
      var imgs = Array.prototype.slice.call(stage.querySelectorAll('.v-reveal-img'));
      var callouts = Array.prototype.slice.call(document.querySelectorAll('.v-reveal-callout'));
      var captions = Array.prototype.slice.call(document.querySelectorAll('.v-reveal-caption-item'));
      var dots = Array.prototype.slice.call(document.querySelectorAll('.v-reveal-progress span'));
      var n = imgs.length;
      if(!n) return;

      /* entrance: the whole stage settles in from a slight tilt + fade, once,
         the first time it scrolls into view — independent of the scrub below */
      gsap.from(stage, {opacity:0, y:40, rotateY:14, duration:1.1, ease:'power3.out',
        scrollTrigger:{trigger:stage, start:'top 82%'}});
      var capWrap = document.querySelector('.v-reveal-caption');
      if(capWrap){
        gsap.from(capWrap, {opacity:0, y:20, duration:.9, ease:'power3.out', delay:.15,
          scrollTrigger:{trigger:stage, start:'top 82%'}});
      }

      function render(active){
        var nearest = Math.max(0, Math.min(n - 1, Math.round(active)));
        imgs.forEach(function(img){ img.classList.toggle('is-active', Number(img.dataset.stage) === nearest); });
        callouts.forEach(function(c){ c.classList.toggle('is-active', Number(c.dataset.stage) === nearest); });
        captions.forEach(function(c){ c.classList.toggle('is-active', Number(c.dataset.stage) === nearest); });
        dots.forEach(function(d){ d.classList.toggle('is-active', Number(d.dataset.stage) === nearest); });
        /* a gentle continuous tilt sells the "turning" feeling as the callouts
           progress; kept small since the side photo already carries its own
           real perspective, so this only needs to nudge it further */
        var tilt = -active * 1.4;
        stage.style.transform = 'rotateY(' + tilt.toFixed(2) + 'deg)';
      }

      render(0);

      if(n > 1){
        var isMobileReveal = window.innerWidth <= 860;
        gsap.to({v:0}, {
          v: n - 1,
          ease:'none',
          scrollTrigger: isMobileReveal ? {
            trigger:'.v-reveal-section', start:'top bottom', end:'bottom top', scrub:0.6
          } : {
            trigger:'.v-reveal-section', start:'top top', pin:true, scrub:0.6,
            end: '+=' + (n * 500),
            invalidateOnRefresh:true
          },
          onUpdate: function(){ render(this.targets()[0].v); }
        });
      }
    })();

    /* ---------- manifesto scrub reveal ---------- */
    var manifesto = document.querySelector('.v-manifesto');
    if(manifesto){
      gsap.timeline({
        scrollTrigger:{trigger:manifesto, start:'top top', end:'+=120%', scrub:0.6, pin:true, invalidateOnRefresh:true}
      }).to(manifesto.querySelectorAll('.mline'), {opacity:1, stagger:0.5});
    }

    /* ---------- spec lines draw + stagger ---------- */
    document.querySelectorAll('[data-draw]').forEach(function(el){
      gsap.to(el, {width:'100%', duration:1, ease:'power3.out', scrollTrigger:{trigger:el, start:'top 88%'}});
    });
    document.querySelectorAll('.v-spec-row').forEach(function(row){
      gsap.from(row.querySelectorAll('.sn, h4, p'), {opacity:0, y:16, duration:.7, stagger:.06,
        scrollTrigger:{trigger:row, start:'top 85%'}});
    });

    /* ---------- closing reveal ---------- */
    var closing = document.querySelector('.v-closing');
    if(closing){
      gsap.from(closing.querySelectorAll('h2, p, .v-closing-form'), {opacity:0, y:24, duration:.8, stagger:.1,
        scrollTrigger:{trigger:closing, start:'top 70%'}});
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function(){ ScrollTrigger.refresh(); });
    }
    window.addEventListener('load', function(){ ScrollTrigger.refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
